export const getConnection = (store) => {
  return store.connection;
};
